import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PasswordModal from './class_SecurityModal';
import { useState } from 'react';

const ListeningModule = ({ module, moduleIndex, expandedModules, toggleModule, expandedClasses, toggleClass, expandedSubClasses, toggleSubClass, expandedSubSubClasses, toggleSubSubClass }) => {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [pendingClass, setPendingClass] = useState(null);
    const [pendingClassName, setPendingClassName] = useState('');

    // ক্লাস ইনডেক্স থেকে env key map
    const classKeyMap = [
        'LIS04_PART1', 'LIS05_PART4', 'LIS06_P2P3', 'LIS07_P2P3', 'LIS08_P2P3', 'LIS09_P2P3'
    ];
    // Combined class password modal state
    const [combinedModalOpen, setCombinedModalOpen] = useState(false);
    const [combinedClassIdx, setCombinedClassIdx] = useState(null);
    const [combinedClassName, setCombinedClassName] = useState('');
    const handleCombinedClick = (classIdx, className) => {
        setCombinedClassIdx(classIdx);
        setCombinedClassName(className);
        setCombinedModalOpen(true);
    };
    const handleCombinedPasswordSuccess = () => {
        setCombinedModalOpen(false);
        setCombinedClassIdx(null);
        setCombinedClassName('');
    };
    const handleCombinedModalClose = () => {
        setCombinedModalOpen(false);
        setCombinedClassIdx(null);
        setCombinedClassName('');
    };

    const handleClassClick = (moduleIdx, classIdx, className) => {
        setPendingClass({ moduleIdx, classIdx });
        setPendingClassName(className);
        setModalOpen(true);
    };

    const handlePasswordSuccess = () => {
        if (pendingClass) {
            toggleClass(pendingClass.moduleIdx, pendingClass.classIdx);
        }
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    return (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
            {/* Module Header */}
            <div
                onClick={() => toggleModule(moduleIndex)}
                className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-100 transition"
            >
                <h2 className="text-xl font-semibold text-[#001670]">{module.name}</h2>
                {expandedModules[moduleIndex] ? (
                    <FaChevronUp className="text-[#001670]" />
                ) : (
                    <FaChevronDown className="text-[#001670]" />
                )}
            </div>

            {/* Expanded Module Content */}
            {expandedModules[moduleIndex] && (
                <div className="px-6 pb-4 space-y-2">
                    {module.classes.map((classItem, classIndex) => {
                        const subKey = `${moduleIndex}-${classIndex}`;
                        if (classIndex <= 0) {
                            // Class 04: Listening Module Part 01
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 04: Listening Module Part 01</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 04 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Basics */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Listening Module: Basics</span>
                                            </div>
                                            {/* 2. Class Lecture Part 01 */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Listening Module: Class Lecture Part 01</span>
                                            </div>
                                            {/* 3. Guided Practices of Part 01 (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Listening Module: Guided Practices of Part 01</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Form Completion */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Guided Practices of Part 01: Form Completion</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div
                                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/guided-practice-01-form' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 01 (Form)</span>
                                                                    </div>
                                                                    <div
                                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/guided-practice-02-form-table' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 02 (Form & Table)</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Table Completion */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 1)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Guided Practices of Part 01: Table Completion</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-1`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/guided-practice-01-table-note' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 01 (Table & Note)</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Note Completion */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 2)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Guided Practices of Part 01: Note Completion</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-2`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/guided-practice-01-note' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 01 (Note)</span>
                                                                    </div>
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/guided-practice-02-note-table' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 02 (Note & Table)</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 1) {
                            // Class 05: Listening Module Part 04
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 05: Listening Module Part 04</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {/* Class 05 Expanded Content */}
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* 1. Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">Listening Module Part 04: Class Lecture</span>
                                            </div>
                                            {/* 2. Guided Practices of Part 04 (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Listening Module: Guided Practices of Part 04</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Note Completion */}
                                                        <div>
                                                            <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 font-semibold text-lg" onClick={() => toggleSubSubClass(subKey, 0)}>
                                                                <span className="text-xl">⇨</span>
                                                                <span>Guided Practices of Part 04: Note Completion</span>
                                                            </div>
                                                            {expandedSubSubClasses[`${subKey}-0`] && (
                                                                <div className="pl-8 pt-2 space-y-2">
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/class-05-guided-practice-01' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 01 (HEXA's Listening Course Book)</span>
                                                                    </div>
                                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                                                        onClick={() => navigate('/listening-instruction', {
                                                                            state: { target: '/class-05-guided-practice-02' }
                                                                        })}
                                                                    >
                                                                        <span className="text-md">▪</span>
                                                                        <span>Guided Practice 02 (Cambridge)</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 2) {
                            // Class 06: Single M.C.Qs
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 06: Listening Module Part 02 & Part 03</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* M.C.Qs : Class Lecture */}
                                            <div className="flex items-center space-x-2">
                                                <span className="text-lg">&#x25B8;</span>
                                                <span className="font-semibold text-lg">M.C.Qs : Class Lecture</span>
                                            </div>
                                            {/* Guided Practices of M.C.Qs (expandable) */}
                                            <div>
                                                <div
                                                    className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                    onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                                >
                                                    <span className="text-lg">&#x25B8;</span>
                                                    <span>Listening Module: Guided Practices of M.C.Qs</span>
                                                </div>
                                                {expandedSubClasses[subKey] && (
                                                    <div className="pl-8 pt-2 space-y-4">
                                                        {/* Guided Practice 01 (Listening Part 02) */}
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                            onClick={() => navigate('/class-06-listening-instruction', { state: { target: '/class-06-guided-practice-01' } })}>
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Guided Practice 01 (Listening Part 02)</span>
                                                        </div>
                                                        {/* Guided Practice 02 (Listening Part 03) */}
                                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                            onClick={() => navigate('/class-06-listening-instruction', { state: { target: '/class-06-guided-practice-02' } })}>
                                                            <span className="text-xl">&#x25B8;</span>
                                                            <span>Guided Practice 02 (Listening Part 03)</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 3) {
                            // Class 07: Double M.C.Qs & Flowchart
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 07: Listening Module Part 02 & Part 03</h3>
                                        {expandedClasses[subKey] ? (
                                            <FaChevronUp className="text-[#001670]" />
                                        ) : (
                                            <FaChevronDown className="text-[#001670]" />
                                        )}
                                    </div>

                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            {/* Class Lecture (acts as sub-toggle) */}
                                            <div
                                                className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                            >
                                                <span className="text-lg">&#x25B8;</span>
                                                <span>Class Lecture from HEXA'S IELTS Preparation Coursebook (Listening)</span>
                                            </div>

                                            {/* Conditionally rendered guided practices */}
                                            {expandedSubClasses[subKey] && (
                                                <div className="pl-8 pt-2 space-y-4">
                                                    {/* Guided Practice 01 */}
                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-07-listening-instruction', { state: { target: '/class-07-guided-practice-01' } })}>
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 01 (Double MCQs Part 02)</span>
                                                    </div>

                                                    {/* Guided Practice 02 */}
                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-07-listening-instruction', { state: { target: '/class-07-guided-practice-02' } })}>
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 02 (Double MCQs Part 03)</span>
                                                    </div>

                                                    {/* Guided Practice 03 */}
                                                    <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-07-listening-instruction', { state: { target: '/class-07-guided-practice-03' } })}>
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 03 (Flow-chart Completion)</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 4) {
                            // Class 08: Matching Information
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 08: Listening Module Part 02 & Part 03</h3>
                                        {expandedClasses[subKey] ? <FaChevronUp className="text-[#001670]" /> : <FaChevronDown className="text-[#001670]" />}
                                    </div>
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            <div
                                                className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                            >
                                                <span className="text-lg">&#x25B8;</span>
                                                <span>Class Lecture from HEXA'S IELTS Preparation Coursebook (Listening)</span>
                                            </div>
                                            {expandedSubClasses[subKey] && (
                                                <div className="pl-8 pt-2 space-y-4">
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-08-listening-instruction', { state: { target: '/class-08-guided-practice-01' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 01 (Matching Information Part 2)</span>
                                                    </div>
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-08-listening-instruction', { state: { target: '/class-08-guided-practice-02' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 02 (Matching Information Part 3)</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (classIndex === 5) {
                            // Class 09: Maps & Diagrams
                            const subKey = `${moduleIndex}-${classIndex}`;
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">Class 09: Listening Module Part 02 & Part 03</h3>
                                        {expandedClasses[subKey] ? <FaChevronUp className="text-[#001670]" /> : <FaChevronDown className="text-[#001670]" />}
                                    </div>
                                    {expandedClasses[subKey] && (
                                        <div className="pl-6 py-2 space-y-2">
                                            <div
                                                className="flex items-center space-x-2 cursor-pointer select-none font-semibold text-lg"
                                                onClick={() => toggleSubClass(moduleIndex, classIndex)}
                                            >
                                                <span className="text-lg">&#x25B8;</span>
                                                <span>Class Lecture from HEXA'S IELTS Preparation Coursebook (Listening)</span>
                                            </div>
                                            {expandedSubClasses[subKey] && (
                                                <div className="pl-8 pt-2 space-y-4">
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-09-listening-instruction', { state: { target: '/class-09-guided-practice-01' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 01 (Map)</span>
                                                    </div>
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-09-listening-instruction', { state: { target: '/class-09-guided-practice-02' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 02 (Map)</span>
                                                    </div>
                                                    <div
                                                        className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200 font-semibold text-lg"
                                                        onClick={() => navigate('/class-09-listening-instruction', { state: { target: '/class-09-guided-practice-03' } })}
                                                    >
                                                        <span className="text-xl">&#x25B8;</span>
                                                        <span>Guided Practice 03 (Diagram)</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                        else {
                            // All other classes in Listening Module
                            return (
                                <div key={classIndex} className="border rounded-md">
                                    <div
                                        className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                    >
                                        <h3 className="font-medium text-[#001670]">{classItem.name}</h3>
                                        {classItem.subClasses ? (
                                            expandedClasses[`${moduleIndex}-${classIndex}`] ? (
                                                <FaChevronUp className="text-[#001670]" />
                                            ) : (
                                                <FaChevronDown className="text-[#001670]" />
                                            )
                                        ) : null}
                                    </div>
                                    {classItem.subClasses && expandedClasses[`${moduleIndex}-${classIndex}`] && (
                                        <div className="px-4 py-2 space-y-2">
                                            {classItem.subClasses.map((subClass, subIndex) => (
                                                <div key={subIndex} className="border rounded-md">
                                                    <div className="px-4 py-3 bg-gray-50 text-[#001670] font-medium">
                                                        {subClass}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    })}
                    
                    <PasswordModal
                        isOpen={modalOpen}
                        onSubmit={handlePasswordSuccess}
                        onClose={handleModalClose}
                        classKey={classKeyMap[pendingClass?.classIdx]}
                        className={pendingClassName}
                    />
                    <PasswordModal
                        isOpen={combinedModalOpen}
                        onSubmit={handleCombinedPasswordSuccess}
                        onClose={handleCombinedModalClose}
                        classKey={classKeyMap[combinedClassIdx]}
                        className={combinedClassName}
                    />
                </div>
            )}
        </div>
    );
};

export default ListeningModule; 